import React from 'react';
import { observer } from 'mobx-react';
import { useStyles } from './style';
import { Typography, Box } from '@material-ui/core';
import Loader from '../Loader';
import { useStores } from '../../hooks/use-stores';

const NextLevelPoints = observer(({ bottomBtn }) => {
    const { LoyaltyStore: store } = useStores();
    const classes = useStyles();

    return (
        <Box className={classes.card}>
            <Typography className={classes.heading}>Баллов до следующего уровня</Typography>
            {store.loading && <Loader p={1} size={40} />}
            {!store.loading && <Typography className={classes.value}>{store.userLevelInfo?.need_points}</Typography>}
            {bottomBtn}
        </Box>
    );
});

export default NextLevelPoints;
